import { CallMethodEnums } from '@/types/api';
import { call } from './utils';

export type DashboardStats = {
  total_invocations: number;
};

export const dashboardStatsGet = async(): Promise<DashboardStats> => {
  return call<unknown, DashboardStats>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/dashboard/stats'
  } );
};
